import { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { apiRequest } from "../api";
import { useAuth, type AuthUser } from "../auth";
import { sitePath, siteResolveQuery, useSiteSlug } from "../site-context";

export function SiteLoginPage() {
  const { slug: paramSlug = "" } = useParams();
  const slug = useSiteSlug(paramSlug);
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [businessName, setBusinessName] = useState("your account");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    const qs = siteResolveQuery(slug, true);
    if (!qs.includes("slug=") && !qs.includes("host=")) return;
    void apiRequest<{ site: { business: { id: string; name: string } } }>(
      `/sites/resolve?${qs}`,
    )
      .then((data) => {
        setBusinessName(data.site.business.name);
      })
      .catch(() => setBusinessName("your account"));
  }, [slug]);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      const session = await apiRequest<{ token: string; user: AuthUser }>(
        "/auth/login",
        {
          method: "POST",
          body: JSON.stringify({ email, password }),
        },
      );
      await setSession(session.token, session.user);
      navigate(sitePath(slug, "portal"));
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="auth-layout">
      <form className="auth-card" onSubmit={onSubmit}>
        <p className="eyebrow">Client portal</p>
        <h1>Log in to {businessName}</h1>
        <p className="notice">Access your bookings with this business.</p>
        <div className="form-grid">
          <label>
            Email
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Password
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button className="btn btn-primary" type="submit" disabled={pending}>
            {pending ? "Signing in..." : "Sign in"}
          </button>
          {error ? <p className="notice error">{error}</p> : null}
          <p className="notice">
            New client?{" "}
            <Link to={sitePath(slug, "register")}>Create an account</Link>
          </p>
          <p className="notice">
            <Link to={sitePath(slug)}>Back to website</Link>
          </p>
        </div>
      </form>
    </div>
  );
}
